import { render, staticRenderFns } from "./AuthenticationPage.vue?vue&type=template&id=2c8e4023&scoped=true&"
import script from "./AuthenticationPage.vue?vue&type=script&lang=js&"
export * from "./AuthenticationPage.vue?vue&type=script&lang=js&"
import style0 from "./AuthenticationPage.vue?vue&type=style&index=0&id=2c8e4023&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8e4023",
  null
  
)

export default component.exports